import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import FooterVideoPlace from "views/FooterVideoPlace/FooterVideoPlace";
import ResponsiveReactPlayer from "views/sidebar/ResponsiveReactPlayer/ResponsiveReactPlayer";

export default function VideoListingAnunciantes() {
  const [filterString, setFilterString] = useState("");
  const [ordernarPor, setOrdernarPor] = useState("");
  const router = useHistory();

  const filter = (str) => {
    if (str != "")
      return String(str)
        .toLowerCase()
        .includes(String(filterString).toLowerCase());
    else return true;
  };

  const handleFilterChange = (e) => {
    setFilterString(e.target.value);
  };
  const handleOdernar = (e) => {
    setOrdernarPor(e.target.value);
  };

  const novidades = [
    {
      url: "https://www.youtube.com/watch?v=MDjZWOTh8x0",
      id: "0000000",
      productName: "Xiaomi",
    },
    {
      url: "https://www.youtube.com/watch?v=BNd_80AR6Gc",
      id: "0000001",
      productName: "IPhone",
    },
    {
      url: "https://www.youtube.com/watch?v=FA4Xhi2c6xs",
      id: "0000002",
      productName: "Motorola",
    },
    {
      url: "https://www.youtube.com/watch?v=Q2KQFp-E3MI",
      id: "000003",
      productName: "Samsung",
    },
  ];
  return (
    <div>
      <Grid container alignItems="flex-start" justifyContent="flex-start">
        <Grid item xs={12}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ paddingTop: "20px" }}
          >
            <Grid item xs={11} sm={10}>
              <Typography variant="h6" color="secondary">
                Anunciante:
              </Typography>
              <Typography variant="h3" color="secondary">
                Xiaomi
              </Typography>
              <br />
            </Grid>
            <Grid item xs={11} sm={3}>
              <Paper
                elevation={3}
                style={{ padding: "15px", background: "white" }}
              >
                <FormControl fullWidth>
                  <Typography variant="body1" color="primary">
                    Buscar:
                  </Typography>
                  <TextField onChange={handleFilterChange} variant="outlined" />
                  <Typography variant="body1" color="primary">
                    Ordenar por:
                  </Typography>
                  <Select
                    value={ordernarPor}
                    onChange={handleOdernar}
                    color="secondary"
                    variant="outlined"
                  >
                    <MenuItem value={"Mais Recente"} style={{ color: "white" }}>
                      Mais Recente
                    </MenuItem>
                    <MenuItem
                      value={"Menos Recente"}
                      style={{ color: "white" }}
                    >
                      Menos Recente
                    </MenuItem>
                    <MenuItem
                      value={"Valor Mais Alto"}
                      style={{ color: "white" }}
                    >
                      Valor Mais Alto
                    </MenuItem>
                    <MenuItem
                      value={"Valor Mais Baixo"}
                      style={{ color: "white" }}
                    >
                      Valor Mais Baixo
                    </MenuItem>
                  </Select>
                </FormControl>
              </Paper>
              <br />
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justifyContent="center">
                {novidades
                  .filter((p) => filter(p.productName))
                  .map((product) => {
                    return (
                      <Grid
                        item
                        sm={parseInt(12 / novidades.length)}
                        xs={12}
                        style={{ marginTop: "30px", marginBottom: "30px" }}
                      >
                        <ResponsiveReactPlayer
                          url={product.url}
                          playing
                          controls={false}
                          muted
                          dividerUp
                          dividerDown
                          loop
                          width="100%"
                          height="200px"
                          onClick={() => router.push("/produto/" + product.id)}
                        />
                      </Grid>
                    );
                  })}
                {novidades
                  .reverse()
                  .filter((p) => filter(p.productName))
                  .map((product) => {
                    return (
                      <Grid
                        item
                        sm={parseInt(12 / novidades.length)}
                        xs={12}
                        style={{ marginTop: "30px", marginBottom: "30px" }}
                      >
                        <ResponsiveReactPlayer
                          url={product.url}
                          playing
                          controls={false}
                          muted
                          dividerUp
                          dividerDown
                          loop
                          width="100%"
                          height="200px"
                          onClick={() => router.push("/produto/" + product.id)}
                        />
                      </Grid>
                    );
                  })}
                {novidades
                  .filter((p) => filter(p.productName))
                  .map((product) => {
                    return (
                      <Grid
                        item
                        sm={parseInt(12 / novidades.length)}
                        xs={12}
                        style={{ marginTop: "30px", marginBottom: "30px" }}
                      >
                        <ResponsiveReactPlayer
                          url={product.url}
                          playing
                          controls={false}
                          muted
                          dividerUp
                          dividerDown
                          loop
                          width="100%"
                          height="200px"
                          onClick={() => router.push("/produto/" + product.id)}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FooterVideoPlace />
        </Grid>
      </Grid>
    </div>
  );
}
